document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq-container').forEach(container => {
        const buttons = container.querySelectorAll('.accordion-button');
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const currentActiveFaq = container.querySelector('.faq-list.active');
                const currentActiveButton = container.querySelector('.accordion-button.active-button');
                const parent = button.parentElement;
                const answer = button.nextElementSibling;
                const arrow = button.querySelector('.arrow');

                if (currentActiveFaq && currentActiveFaq !== parent) {
                    currentActiveFaq.classList.remove('active');
                    currentActiveButton.classList.remove('active-button');
                    toggleAnswer(currentActiveFaq.querySelector('.faq-answer'), currentActiveFaq.querySelector('.arrow'), false);
                }

                toggleAnswer(answer, arrow, !parent.classList.contains('active'));
                parent.classList.toggle('active');
                button.classList.toggle('active-button');
            });
        });
    });
});

const toggleAnswer = (answer, arrow, show) => {
    if (show) {
        answer.style.display = 'block';
        answer.style.maxHeight = `${answer.scrollHeight}px`;
        arrow.classList.add('rotate');
    } else {
        answer.style.maxHeight = '0';
        arrow.classList.remove('rotate');
        answer.addEventListener('transitionend', () => {
            answer.style.display = 'none';
        }, { once: true });
    }
};